module.exports = __webpack_public_path__ + "img/BG.5c497b2e.svg";